import { Controller } from "@hotwired/stimulus"
import {
  base64UrlToArrayBuffer,
  hasTekInSession,
  getTekFromSession,
  wrapTekWithUek
} from "../crypto"

export default class extends Controller {
  static values = {
    approveUrl: String,
    uekPublicKey: String
  }

  async approve(event) {
    event.preventDefault()
    event.stopPropagation()

    try {
      if (!(await hasTekInSession())) {
        alert("Je moet eerst zelf ingelogd zijn om een gebruiker goed te keuren.")
        return
      }

      // Unwrap TEK using admin's stored UEK
      const tekRaw = await getTekFromSession()

      // Import user's UEK public key
      const uekPublicKey = await window.crypto.subtle.importKey(
        "spki",
        base64UrlToArrayBuffer(this.uekPublicKeyValue),
        { name: "ECDH", namedCurve: "P-256" },
        false,
        []
      )

      // Wrap TEK with user's UEK
      const tekWrapped = await wrapTekWithUek(tekRaw, uekPublicKey)

      // Send wrapped TEK to server
      const response = await fetch(this.approveUrlValue, {
        method: "POST",
        headers: this.jsonHeaders(),
        body: JSON.stringify({ tek_wrapped: tekWrapped })
      })

      const result = await response.json()

      if (!response.ok) {
        throw new Error(result.error || "Goedkeuren mislukt.")
      }

      // Show success flash message and redirect
      if (result.redirect_to) {
        window.location.href = result.redirect_to
      } else {
        window.location.reload()
      }
    } catch (error) {
      alert(error.message)
    }
  }

  jsonHeaders() {
    const token = document.querySelector("meta[name='csrf-token']")?.content
    return {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": token
    }
  }

  showFlash(message) {
    const flashContainer = document.getElementById("flash")
    if (flashContainer) {
      const flash = document.createElement("div")
      flash.className = "flash flash--notice"
      const content = document.createElement("div")
      content.className = "flash-content"
      const span = document.createElement("span")
      span.textContent = message
      content.appendChild(span)
      flash.appendChild(content)
      flashContainer.appendChild(flash)
      setTimeout(() => flash.remove(), 5000)
    }
  }
}
